import React, { useEffect, useContext, useState, useCallback } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import VideoPlayer from "./videoPlayer"
import { ScrollContext } from "../context/scrollContext"

const Gallery = ({ assets, thumbnails, color }) => {
  const { scrollActions: { scrollTo } } = useContext(ScrollContext)


  const onClick = (e, index) => {
    scrollTo(`div[data-gallery="${index}"]`)
  }

  console.log(assets);

  return (
    <div className='project--gallery gallery--grid p10'>
      <div className='gutter m-hide' id='gutter'>
        <div className='w-100 max-100' data-scroll-sticky data-scroll-target='#gutter' data-scroll data-scroll-offset='-50'>
          <div className="flex w-100">
            <div className="flex flex-col w-100 last-mb0">
              {thumbnails.map((thumbnail, index) => {
                return (
                  <div data-thumbnail={index} className={'gallery--thumbnail mb2  w-100 '} key={index} onClick={(e) => onClick(e, index)} onFocus={(e) => onClick(e, index)} role='presentation'>
                    <div className={'w-100 pointer-none pos-rel overflow-hidden bg-dark ' + thumbnail.assetRatio}>
                      {(thumbnail.videoLink ?
                        <div className="bg-image video-wrapper">
                          <VideoPlayer url={thumbnail.videoLink} />
                        </div>
                        :
                        <GatsbyImage className='bg-image' image={thumbnail.imageAsset?.gatsbyImageData} alt='Project Thumbnail' />
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
            <div className='indicator-wrapper'>
              <Indicator total={thumbnails.length} />
            </div>
          </div>
          <div style={{ height: '60px' }} />
        </div>
      </div>
      <div className='gallery last-pb0' data-scroll-call='reset' data-scroll-repeat="true" data-scroll data-scroll-offset={`100vh`} data-scroll-id={`gallery-image`}>
        {assets.map((asset, index) => {
          return (
            <div data-gallery={index} className='gallery--item pb10 ' key={index}>
              <div className={'pos-rel overflow-hidden bg-dark ' + asset.assetRatio} style={{ background: color?.hex }}>
                {(asset.videoLink ?
                  <div className="bg-image video-wrapper">
                    <VideoPlayer url={asset.videoLink} />
                  </div>
                  :
                  <GatsbyImage className='bg-image' image={asset.imageAsset?.gatsbyImageData} alt='Project Image' />
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
export default Gallery


const Indicator = ({ total }) => {
  const { scrollActions: { registerHandler } } = useContext(ScrollContext)

  const [currentImage, setCurrentImage] = useState(0)

  const transitionHandler = useCallback(({ currentElements }) => {

    if (currentElements['gallery-image']) {

      const progress = Math.round(currentElements['gallery-image'].progress * 100)
      if (progress < 50) {
        setCurrentImage(Math.max(progress, 0))
      } else {
        setCurrentImage(Math.min(progress, 97))
      }

    }

  }, [setCurrentImage])

  const reset = useCallback((_, direction, el) => {
    if (direction === 'exit') {
      if (el.progress < 0.1) {
        setCurrentImage(0)
      } else {
        setCurrentImage(97)
      }
    }
  }, [setCurrentImage])


  useEffect(() => {
    registerHandler('scroll', transitionHandler, 100)
    registerHandler('call', reset, 0)
  }, [registerHandler, reset, transitionHandler])



  return (
    <div style={{ transform: `translateY(${currentImage}%)` }} className="h-100 indicator-wrapper">
      <div className="flex flex-col justify-start" style={{ height: `${(1 / total) * 100}%` }}>
        <div className="indicator" />
      </div>
    </div>

  )
}